import InfoMessageListResourceModel from '../../generated/types/model/resource/InfoMessageListResourceModel';

export default class InfoMessageListResourceViewModel extends InfoMessageListResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
